export function getDelayedMessageTime(message: Message): number {
  const textLength = (<BubbleData>message.messageComponent?.componentData)
    ?.cardText?.length;
  return (textLength ? textLength : 0) * 20;
}
